import { useManageOrder } from 'hooks/useManageOrder';
import React, { createContext } from 'react';

export const ManageOrderContext = createContext({} as ReturnType<typeof useManageOrder>);

interface IProps {
  children: React.ReactNode;
}
export const ManageOrderProvider = ({ children }: IProps) => {
  const config = useManageOrder();
  return <ManageOrderContext.Provider value={config}>{children}</ManageOrderContext.Provider>;
};
